import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useChartData } from '../../context/ChartContext';
import { useScaleChecked } from '../../context/ScaleContext';
import useSpectrum from '../../hooks/useSpectrum';
import { useActiveSpectrum } from '../../reducer/Reducer';
import getVerticalShift from '../utilities/getVerticalShift';
import PeakAnnotation from './PeakAnnotation';
const emptyData = { peaks: {}, info: {}, display: {} };
function PeakAnnotations() {
    const { verticalAlign, displayerKey } = useChartData();
    const activeSpectrum = useActiveSpectrum();
    const { scaleX, scaleY } = useScaleChecked();
    const spectrum = useSpectrum(emptyData);
    const Peaks = useMemo(() => {
        const getVerticalAlign = () => {
            return getVerticalShift(verticalAlign, { index: activeSpectrum?.index });
        };
        if (!spectrum?.peaks?.values ||
            !spectrum.display.isVisible ||
            !spectrum.display.isPeaksMarkersVisible) {
            return null;
        }
        return (_jsx("g", { transform: `translate(0,-${getVerticalAlign()})`, children: spectrum.peaks.values.map(({ x, y, id }) => (_jsx(PeakAnnotation, { x: scaleX()(x), y: scaleY(spectrum.id)(y) - 5, sign: Math.sign(y), id: id, value: x, color: "#730000", nucleus: spectrum.info.nucleus }, id))) }));
    }, [spectrum, verticalAlign, activeSpectrum?.index, scaleX, scaleY]);
    return (_jsx("g", { className: "peaks", clipPath: `url(#${displayerKey}clip-chart-1d)`, children: Peaks }));
}
export default PeakAnnotations;
